<aa-popin-v3 [isShown]="isShown"
             [onClose]="onClosePopin"
             [width]="52"
             [backPic]="'forms'"
             [hasCancelButton]="true">
    <span class="title">{{ 'ITSM.CREATECASEPOPIN.POPINTITLE' | translate }}</span>
    <div class="popin-content-body">
        <form id="create-case-form"
              [formGroup]="formGroup">
            <div class="title">
                <aa-input-text2 name="title"
                                required
                                label="{{ 'ITSM.CREATECASEPOPIN.TITLE' | translate }}"
                                [formControlName]="titleField">
                </aa-input-text2>
            </div>
            <div class="form-header">
                {{ 'ITSM.CREATECASEPOPIN.URGENCY' | translate }}
            </div>
            <div class="urgency">
                <aa-radio-group3 [formControlName]="urgencyIdField"
                                 orientation="horizontal"
                                 [name]="urgencyIdField"
                                 [options]="urgencyOptions"
                                 [marginTop]="0"
                                 [required]="'required'">
                </aa-radio-group3>
            </div>
            <div class="form-header category">
                {{ 'ITSM.CREATECASEPOPIN.CATEGORY' | translate }}
            </div>
            <div>
                <aa-input-treeview2 #inputTreeview
                                    [formControlName]="catalogField"
                                    [treeModel]="this.catalog | async"
                                    [name]="catalogField"
                                    [height]="200">
                </aa-input-treeview2>
            </div>
            <div class="form-header">
                {{ 'ITSM.CREATECASEPOPIN.DESCRIPTION' | translate }}
            </div>
            <div class="description">
                <aa-input-editor [name]="descriptionField"
                                 [formControlName]="descriptionField"
                                 label="{{ 'ITSM.CREATECASEPOPIN.DESCRIPTIONPLACEHOLDER' | translate }}"
                                 [required]="'required'">
                </aa-input-editor>
            </div>
            <div class="files">
                <aa-upload-files #filesToUpload
                                 [name]="fileToUploadField"
                                 [formControlName]="fileToUploadField"
                                 [prompt]="'ITSM.CREATECASEPOPIN.PROMPT' | translate"
                                 (filesChangeEmiter)="onFilesChange($event)"
                                 [height]="'10vh'"
                                 [width]="'10vw'"
                                 [autoClear]="false">
                </aa-upload-files>
            </div>
        </form>
    </div>
    <div class="popin-content-footer">
        <aa-btn-action-secondary [disabled]="formGroup.invalid" [btnText]="'BUTTON.CREATE' | translate"
                                 [cta]="onCreate">
        </aa-btn-action-secondary>
    </div>
</aa-popin-v3>
